import { render, staticRenderFns } from "./CustomerCreditLetterTab.vue?vue&type=template&id=2e9ddf60&scoped=true&"
import script from "./CustomerCreditLetterTab.vue?vue&type=script&lang=js&"
export * from "./CustomerCreditLetterTab.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCreditLetterTab.vue?vue&type=style&index=0&id=2e9ddf60&prod&lang=sass&"
import style1 from "./CustomerCreditLetterTab.vue?vue&type=style&index=1&id=2e9ddf60&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9ddf60",
  null
  
)

export default component.exports